// extracted by mini-css-extract-plugin
export default {"recos":"H4-z","productCardOverride":"I4-z","rowHasBadge":"J4-z"};